import React from 'react';
import { Link } from 'react-router-dom';
import { FaBed, FaMapMarkerAlt, FaPlane, FaPhone } from 'react-icons/fa';
import './Travel.css';

const Travel = () => {
  const hotels = [
    {
      name: "Hotel K Fortune",
      address: "Nandyal Road, near G Pullareddy Engineering College, Siddartha Nagar, Kalluru, Andhra Pradesh 518007",
      phone: "085182 27222"
    },
    {
      name: "Hotel Triguna",
      address: "D no 51, 1 1a-4, Kallur Rd, behind RTC Bustand, Kallur, Sampath Nagar, Kurnool, Andhra Pradesh 518003",
      phone: "063019 58505"
    },
    {
      name: "Hotel DVR Mansion",
      address: "Plot No.40-839, SBI Circle Opp Children's Park, Andhra Pradesh 518004",
      phone: "085182 21111"
    },
    {
      name: "Maurya Inn",
      address: "40/304, Bhagya Nagar, River View Colony, Kurnool, Andhra Pradesh 518004",
      phone: "085182 24999"
    }
  ];

  return (
    <div className="travel-page">
      {/* Header Section */}
      <div className="travel-page-header">
        <div className="travel-container">
          <h1 className="travel-page-title"><FaPlane /> Travel</h1>
          <p className="travel-page-subtitle">Complete information about travel support and accommodation options</p>
        </div>
      </div>

      <div className="travel-container">
        <div className="travel-content">
          {/* Travel Support Card */}
          <div className="travel-card">
            <div className="travel-card-header">
              <FaPlane className="travel-card-icon" />
              <h2>Travel Support</h2>
            </div>
            <div className="travel-card-body">
              <p className="travel-text">
                Travel support for the shortest route by <strong>bus (public transport)</strong> or <strong>AC 3-tier train</strong> will be provided to participants upon submission of original bills.
              </p>
              
              <h3 className="travel-subheading">Travel Support Details:</h3>
              <ul className="travel-features">
                <li><strong>Eligible Modes:</strong> Public transport (bus) or AC 3-tier train</li>
                <li><strong>Shortest Route:</strong> Support provided for the shortest route only</li>
                <li><strong>Requirements:</strong> Original bills/receipts must be submitted</li>
                <li><strong>Reimbursement:</strong> Reimbursement will be processed after the conference</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Travel;
